// Unicode-safe anchors: PostgreSQL substr counts code points, not UTF-16 units.
// Keep the exact selected substring; never trust client-provided quote at the RPC.
export const chars = s=>Array.from(String(s||''));
export function storyAnchor(text,start,end){
 const letters=chars(text);
 if(!Number.isInteger(start)||!Number.isInteger(end)||start<0||end<=start||end>letters.length)return null;
 return {start,end,quote:letters.slice(start,end).join('')};
}
export function selectionInParagraph(paragraph,selection=window.getSelection()){
 if(!paragraph||!selection||selection.isCollapsed||selection.rangeCount!==1)return null;
 const range=selection.getRangeAt(0);
 if(!paragraph.contains(range.startContainer)||!paragraph.contains(range.endContainer))return null;
 const prefix=range.cloneRange();
 prefix.selectNodeContents(paragraph);
 prefix.setEnd(range.startContainer,range.startOffset);
 const start=chars(prefix.toString()).length;
 const chosen=chars(range.toString());
 if(!chosen.length||!range.toString().trim()||chosen.length>5000)return null;
 return storyAnchor(paragraph.textContent,start,start+chosen.length);
}
export function storyExcerpt(text,comment){
 if(!comment)return null;
 const original=storyAnchor(text,comment.start_char,comment.end_char);
 if(original?.quote===comment.quote)return original;
 const i=String(text).indexOf(comment.quote);
 if(i<0)return null;
 const start=chars(String(text).slice(0,i)).length;
 return storyAnchor(text,start,start+chars(comment.quote).length);
}
